<div style="height: 93vh">
    <ac-map>
        <!-- <billboard-layer-devices></billboard-layer-devices> -->
        <app-html-layer-devices (openTipoDatosModalEmitter)='openTipoDatosModal()' (openDatosModalEmitter)='openDatosModal($event)'></app-html-layer-devices>
    </ac-map>
</div>